<div *ngIf="isLoading | async" class="loader-overlay">
    <div class="spinner"></div>
</div>